// extracted by mini-css-extract-plugin
export var discard = "_25-4";
export var muiTooltipTooltip = "_25-6";
export var notificationBar = "_25-3";
export var notificationContainer = "_25-2";
export var saveButtonHoverSlotWrapper = "_25-5";
export var show = "_25-1";
export var spacer = "_25-0";